module.exports = {"attributes":{"width":"18","height":"14","viewBox":"0 0 18 14","xmlns":"http://www.w3.org/2000/svg"},"content":"<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3.0001 1.75C2.58588 1.75 2.2501 2.08579 2.2501 2.5V2.83797L8.62745 6.89048C8.73926 6.9601 8.86836 6.99701 9.0001 6.99701C9.13183 6.99701 9.26093 6.9601 9.37274 6.89048L15.7501 2.83797V2.5C15.7501 2.08579 15.4143 1.75 15.0001 1.75H3.0001ZM17.2501 3.23735V2.5C17.2501 1.25736 16.2427 0.25 15.0001 0.25H3.0001C1.75745 0.25 0.750095 1.25736 0.750095 2.5V3.23735C0.749968 3.24531 0.749968 3.25328 0.750095 3.26124V11.5C0.750095 12.7426 1.75745 13.75 3.0001 13.75H15.0001C16.2427 13.75 17.2501 12.7426 17.2501 11.5V3.26124C17.2502 3.25328 17.2502 3.24532 17.2501 3.23735ZM15.7501 4.6152L10.1708 8.16058C9.8199 8.38042 9.41418 8.49701 9.0001 8.49701C8.58601 8.49701 8.1803 8.38041 7.8294 8.16056L7.82534 8.15802L2.2501 4.6152V11.5C2.2501 11.9142 2.58588 12.25 3.0001 12.25H15.0001C15.4143 12.25 15.7501 11.9142 15.7501 11.5V4.6152Z\"/>"}
const React = require('react');

function svgLoader(svg) {
	const { viewBox, width, height } = svg.attributes;

	// eslint-disable-next-line react/display-name
	return function (props) {
		return React.createElement(
			'svg',
			Object.assign(
				{
					dangerouslySetInnerHTML: { __html: svg.content },
					fill: 'currentColor',
					height,
					viewBox,
					width,
				},
				props,
			),
		);
	};
}

module.exports = svgLoader(module.exports);
